/*------------------------------------*\
    MODULES
\*------------------------------------*/
import { Collapse } from 'bootstrap';
import Header from './modules/header';
import Nav from './modules/nav';
import Scrollspy from './modules/scrollspy';
import TypeMate from 'typemate';

/*------------------------------------*
    APP
\*------------------------------------*/
const app = {

    init() {
        this.noJs();
        this.alwaysLoad();
        this.bind();
    },

    bind() {

        // Load any items that need modules
        let modulePlaceHolders = [...document.querySelectorAll('[data-module]')];

        // No modules so bail
        if (!modulePlaceHolders.length) {
            return;
        }

        modulePlaceHolders.map((item) => {

            // Attempt to load any modules
            let modules = item.getAttribute('data-module');

            if (!modules.length) {
                return false;
            }

            // Split the modules into an array
            modules = modules.trim().split(',');

            // Loop and bind to relevant modules
            modules.map((module) => {

                switch (module.trim()) {

                    case 'header':

                        let headerInstance = new Header(item);

                        headerInstance.init();

                        break;

                    case 'nav':

                        let navInstance = new Nav(item);

                        navInstance.init();

                        break;

                    case 'scrollspy':

                        let scrollspyInstance = new Scrollspy(item);

                        scrollspyInstance.init();

                        break;
                }
            });
        });
    },

    alwaysLoad() {
        // Typemate
        const typeMateInstance = new TypeMate(document.body);
        typeMateInstance.apply();
    },

    noJs() {
        document.documentElement.classList.remove('no-js');
        document.documentElement.classList.add('js');
    }
};

// Launch
app.init();
